const UserProfilePropsDefault = [
    'sub',
    'email',
    'email_verified',
    'preferred_username',
    'name',
    'given_name',
    'family_name',
    'middle_name',
    'nickname',
    'profile',
    'picture',
    'website',
    'gender',
    'birthdate',
    'zoneinfo',
    'locale',
    'phone_number',
    'phone_number_verified',
    'address',
    'updated_at'
];

/**
 * @param {import('./jwt').UserProfile} profile
 * @return {import('./jwt').UserProfileWithAttributes}
 */
export const createUserProfileWithAttributes = (profile) => {
    const attributes = {};
    const profileWithAttrs = Object.entries(profile).reduce((acc, [key, val]) => {
        const isDefault = UserProfilePropsDefault.includes(key);
        if (isDefault) {
            return { ...acc, [key]: val };
        }
        attributes[key] = val;
        return acc;
    }, {});

    return { ...profileWithAttrs, attributes };
};
